/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MailMagazineManagementListSenderResponse } from './MailMagazineManagementListSenderResponse';

export type MailMagazineManagementListSenderResponseApiRespoonse = {
    data?: MailMagazineManagementListSenderResponse;
    status?: MailMagazineManagementListSenderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MailMagazineManagementListSenderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

